'use client'

import { X } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@/components/ui/dialog'

interface VideoDialogProps {
  videoTitle: string | null | undefined
  videoEmbedUrl: string | null | undefined
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function VideoDialog({ videoTitle, videoEmbedUrl, open, onOpenChange }: VideoDialogProps) {
  if (!videoEmbedUrl) return null

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-6xl border-none bg-transparent p-0" customCloseButton>
        <DialogClose asChild>
          <Button
            variant="icon"
            color="inverse"
            customIcon={<X className="size-4" />}
            className="absolute -top-4 right-2 z-10 md:-right-2"
          />
        </DialogClose>
        <DialogTitle className="sr-only">{videoTitle}</DialogTitle>
        <DialogDescription className="sr-only">Video about {videoTitle}</DialogDescription>
        <div className="relative wrapper">
          <iframe
            src={videoEmbedUrl}
            className="mx-auto aspect-video w-full rounded-lg object-cover object-center"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture focus:outline-none focus-visible:ring-1 focus-visible:ring-evergreen-300 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent"
            allowFullScreen
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
